
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9jOdE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6d465fd2334065e1$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Swedish
var $22f72f117dee8689$export$2e2bcd8739ae039 = {
    'extension.charts.aggregateData': 'Samla data',
    'extension.charts.aggregateDataDescription': "Kombinera v\xe4rden till en enda datapunkt n\xe4r flera rader har samma v\xe4rde.",
    'extension.charts.category': 'Kategori',
    'extension.charts.customizeTab': 'Anpassa',
    'extension.charts.dataMissing.details': "Vi hittar inte diagrammets k\xe4lltabell p\xe5 sidan.",
    'extension.charts.dataMissing.title': 'Inga data att visa',
    'extension.charts.dataTab': 'Data',
    'extension.charts.defaultColumnName': 'Kolumn {0}',
    'extension.charts.defaultTitle': "Namnl\xf6st diagram",
    'extension.charts.defaultYLabel': "Namnl\xf6s axel",
    'extension.charts.extensionTitle': 'Diagram',
    'extension.charts.height': "Diagrammets h\xf6jd",
    'extension.charts.height.large': "H\xf6gre",
    'extension.charts.height.medium': 'Standard',
    'extension.charts.height.small': 'Kortare',
    'extension.charts.horizontal.orientation.label': 'Horisontellt',
    'extension.charts.insert.tooltip': 'Infoga diagram',
    'extension.charts.legend': "F\xf6rklaring",
    'extension.charts.legend.auto': 'Auto',
    'extension.charts.legend.bottom': 'Under',
    'extension.charts.legend.left': "V\xe4nster",
    'extension.charts.legend.position': "F\xf6rklaringens position",
    'extension.charts.legend.right': "H\xf6ger",
    'extension.charts.legend.show': "Visa f\xf6rklaring",
    'extension.charts.legend.top': "\xd6ver",
    'extension.charts.options.label': 'Diagramalternativ',
    'extension.charts.options.tooltip': "\xc4ndra diagramalternativ",
    'extension.charts.orientation.label': 'Riktning',
    'extension.charts.seriesNames': 'Dataserie',
    'extension.charts.showPoints': 'Visa datapunkter',
    'extension.charts.smoothLines': "J\xe4mna linjer",
    'extension.charts.style': 'Stil',
    'extension.charts.title': 'Titel',
    'extension.charts.type.bar': 'Stapel',
    'extension.charts.type.fieldDescription': 'Diagramtyp',
    'extension.charts.type.line': 'Linje',
    'extension.charts.type.pie': 'Cirkel',
    'extension.charts.userTitle': 'Titel',
    'extension.charts.vertical.orientation.label': 'Vertikalt',
    'extension.charts.xAxis': 'X-axel',
    'extension.charts.xLabel': "Etikett f\xf6r X-axel",
    'extension.charts.yLabel': "Etikett f\xf6r Y-axel"
};


var $6d465fd2334065e1$export$2e2bcd8739ae039 = (0, $22f72f117dee8689$export$2e2bcd8739ae039);

});


//# sourceMappingURL=sv.2f983634.js.map
